module.exports = __webpack_public_path__ + "static/media/bau.c04984b2.jpg";